import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "_tc--primary _mr-2" }
const _hoisted_2 = ["src"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_tooltip = _resolveComponent("tooltip")

  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _createVNode(_component_tooltip, {
      class: "_flexinline _ai-c _cur-d",
      text: $props.tooltipText
    }, {
      default: _withCtx(() => [
        _createElementVNode("img", {
          height: "14",
          src: $props.icon
        }, null, 8 /* PROPS */, _hoisted_2)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["text"])
  ]))
}